export function hasSessionToken(): boolean {
  const token = localStorage.getItem('token');
  const abilities = localStorage.getItem('abilities');
  return token !== null && token !== '' && abilities !== null && abilities !== '';
}

export function isSessionExpired(): boolean {
  const expires = localStorage.getItem('expires');
  return expires !== null && new Date(expires) < new Date();
}